import { ofetch } from 'ofetch'
export interface ApiFetchOptions<T = any> {
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  headers?: Record<string, string>;
  body?: T;
  query?: Record<string, any>;
}

export interface IResponse<T> {
  status: number;
  _data: T;
}

export default (baseURL: string) => {
  const fetchApi = async <TBody = any, TResponse = IResponse<TBody>>(
    path: string,
    options: ApiFetchOptions<TBody> = {},
  ): Promise<IResponse<TBody>> => {
    try {
      const headers: Record<string, string> = {
        ...(options.headers || {}),
      }

      return await ofetch.raw<TResponse>(path, {
        baseURL,
        method: options.method || 'GET',
        headers,
        body: options.body,
        query: options.query,
      })
    } catch (error) {
      console.error(`[API] ${path}`, error)
      throw error
    }
  }

  return { fetchApi }
}
